jQuery(document).ready(function () {
  jQuery(".case-study-listing-block_sec").each(function (index) {
    let slider = jQuery(this).find(
      ".case-study-listing-block_sec__wrapper.slider .case-study-listing"
    );
    jQuery(slider).slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: false,
      autoplay: false,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            variableWidth: false,
            slidesToShow: 1,
          },
        },
      ],
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const radioButtons = document.querySelectorAll('input[name="catName"]');
  const restbtn = document.querySelector(".reset_btn_wrap");

  if (radioButtons.length > 0) {
    radioButtons[0].checked = true;
  }
  if (restbtn) {
    restbtn.addEventListener("click", function () {
      radioButtons[0].checked = true;
    });
  }
});
// document.addEventListener("DOMContentLoaded", function () {
//   const selectWrapper = document.querySelector(".select_dropdown");
//   const selectElement = selectWrapper.querySelector(".option_list");
//   const optionElement = selectWrapper.querySelector(".option_list__item");

//   selectElement.addEventListener("click", function (event) {
//     event.stopPropagation();
//     selectWrapper.classList.add("active");
//   });
//   optionElement.addEventListener("click", function (event) {
//     selectWrapper.classList.remove("active");
//   });

//   selectElement.addEventListener("change", function () {
//     selectWrapper.classList.remove("active");
//   });

//   document.addEventListener("click", function (event) {
//     if (!selectWrapper.contains(event.target)) {
//       selectWrapper.classList.remove("active");
//     }
//   });
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const select = document.getElementById(".select_dropdown .option_list");

//   select.addEventListener("click", () => {
//     select.classList.add("active");
//   });

//   select.addEventListener("change", () => {
//     // Remove active class if an option is selected or if the first placeholder option is selected
//     if (select.value) {
//       select.classList.remove("active");
//     }
//   });

//   document.addEventListener("click", (event) => {
//     // Remove active class if clicking outside the select element
//     if (!select.contains(event.target)) {
//       select.classList.remove("active");
//     }
//   });
// });
